import { Component, OnInit } from '@angular/core';
import { JobService } from 'src/app/services/job.service';
import { Router } from '@angular/router';
import { from } from 'rxjs';

@Component({
  selector: 'app-job-list',
  templateUrl: './job-list.component.html',
  styleUrls: ['./job-list.component.scss']
})
export class JobListComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))

  constructor(private _JobListService: JobService, private router: Router) { }

  isCollapsed = false;
  JobList: any

  flag: any

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    this._JobListService.getJobList().subscribe(result => {
      if (result[0].returncode == "1000") {
        this.JobList = result;
        if (result[0].id != "") {
          // this.JobList = result;
        }
      }
    });

  }
  Detail(id) {
    // console.log(this.JobList)
    //  localStorage.setItem("id", id);
    // this.router.navigate(['/job-detail']);

    this.router.navigate(['/job-detail'], { queryParams: { jobid: id, } });
  }

}
